import React, { useEffect, useMemo, useState } from "react";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

import ConfirmationModal from "components/Modals/ConfirmationModal";
import AssignmentDataTable from "components/TableContainers/AssignmentDataTable";
import {
  deleteAssignmentRequest,
  addAssignmentRequest,
  updateAssignmentRequest,
} from "store/assignment/actions";

const AssignmentTable = ({
  assignments,
  loading,
  totalrows,
  // 🔹 Controlled states from parent
  pageIndex,
  setPageIndex,
  pageSize,
  setPageSize,
  searchString,
  setSearchString,
  selectedCreator,
  setSelectedCreator,
  selectedStatus,
  setSelectedStatus,
  selectedSortData,
  setSelectedSortData,
  creatorOptions,
}) => {
  const dispatch = useDispatch();

  // Modal states
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);

  //  Handle delete confirmation
  useEffect(() => {
    if (deleteId && confirmAction) {
      dispatch(deleteAssignmentRequest(deleteId));
      setOpenModal(false);
      setConfirmAction(false);
    }
  }, [confirmAction, deleteId, dispatch]);

  //  Table Columns
  const columns = useMemo(
    () => [
      {
        header: "#",
        id: "serial",
        cell: ({ row }) => (pageIndex - 1) * pageSize + row.index + 1,
      },
      {
        header: "Title",
        accessorKey: "title",
      },
      {
        header: "Deadline",
        accessorKey: "deadline",
      },
      {
        header: "Total Marks",
        accessorKey: "totalMarks",
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: ({ row }) => (
          <span
            className={`badge ${
              row.original.status === "Active" ? "bg-success" : "bg-secondary"
            }`}
          >
            {row.original.status}
          </span>
        ),
      },
      {
        header: "Created By",
        accessorKey: "createdBy.name",
        cell: ({ row }) => row.original?.createdBy?.name || "-",
      },
      {
        header: "Actions",
        id: "actions",
        cell: ({ row }) => {
          const handleEdit = () => {
            setEditData(row.original);
            setIsOpen(true);
          };

          const handleDelete = () => {
            setDeleteId(row.original._id);
            setOpenModal(true);
          };

          return (
            <div className="d-flex gap-2">
              <Button color="primary" onClick={handleEdit} title="Edit">
                <FaRegEdit size={18} />
              </Button>
              <Button color="danger" onClick={handleDelete} title="Delete">
                <MdDeleteOutline size={18} />
              </Button>
            </div>
          );
        },
      },
    ],
    [pageIndex, pageSize]
  );

  //  Handle Form Submit (add/edit)
  // const handleFormSubmit = (id, data, onClose) => {
  //   if (id) {
  //     dispatch(updateAssignmentRequest(id, data, onClose));
  //   } else {
  //     dispatch(addAssignmentRequest(data, onClose));
  //   }
  // };

  return (
    <>
      {/*  Delete Confirmation Modal */}
      {/* <ConfirmationModal
        okText="Confirm"
        onCancel={() => setOpenModal(false)}
        onOk={() => setConfirmAction(true)}
        isVisible={openModal}
        title="Delete Assignment"
        content="Are you sure you want to delete this assignment?"
      /> */}

      {/*  Create/Edit Modal */}
      {/* <CreateAssignment
        visible={isOpen}
        initialData={editData}
        onSubmit={handleFormSubmit}
        handleClose={() => {
          setIsOpen(false);
          setEditData(null);
        }}
      /> */}

      {/*  Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* <Button
          className="bg-primary text-white d-flex align-items-center gap-1"
          onClick={() => setIsOpen(true)}
        >
          <i className="ti-plus"></i> Add New
        </Button> */}
      </div>

      {/*  Data Table */}
      <AssignmentDataTable
        data={assignments || []}
        loading={loading}
        totalrows={totalrows}
        // 🔹 Controlled props from parent
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        setPageSize={setPageSize}
        searchString={searchString}
        setSearchString={setSearchString}
        selectedCreator={selectedCreator}
        setSelectedCreator={setSelectedCreator}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        selectedSortData={selectedSortData}
        setSelectedSortData={setSelectedSortData}
        creatorOptions={creatorOptions}
      />
    </>
  );
};

export default AssignmentTable;
